import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { IProgramBeneficiary } from "@pbm/beneficiaries/contracts";
import { usePbm2Url } from "@common/hooks/usePbm2Url";

export function useProgramBeneficiary(programCode: string, id: string) {
  const { request } = usePbm2Url();
  return useQuery(`programBeneficiary:${programCode}:${id}`, async () => {
    const {
      Beneficiaries_programsBeneficiaries: { edges },
    } = await request(
      gql`
        query Beneficiaries_programsBeneficiaries(
          $programCode: String!
          $id: String!
        ) {
          Beneficiaries_programsBeneficiaries(
            filter: { programCode: [$programCode], id: [$id] }
          ) {
            edges {
              cursor
              node {
                id
                customerCode
                name
                createdAt
                origin
                storeCode
                program {
                  code
                  name
                  type
                  createdAt
                  updatedAt
                }
                fields {
                  text
                  value
                }
                programFamilyBeneficiaries {
                  edges {
                    node {
                      origin
                      storeCode
                      createdAt
                      programFamily {
                        code
                        name
                      }
                      fields {
                        text
                        value
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `,
      { programCode, id }
    );
    const programBeneficiary: IProgramBeneficiary =
      (edges || []).map(({ node }: { node: IProgramBeneficiary }) => node)[0] ||
      {};

    programBeneficiary.programFamilyBeneficiaries =
      edges[0]?.node?.programFamilyBeneficiaries?.edges.map(
        ({ node }: any) => node
      );

    return programBeneficiary;
  });
}
